// extracted by mini-css-extract-plugin
export default {"matchingHelp":"Pi72N26oSvSEXm2aAGi9","icon":"FsaojvLgOEZRw9CwF0md","tagsContainer":"a5sTc_XC6yhqjqXMtFwY"};